import {Communication} from "types/communication"

const decodeEntities = (html: string) => {
    // textarea content is RCDATA: entities are decoded, no elements are created
    const textarea = document.createElement("textarea")
    textarea.innerHTML = html
    return textarea.value
}

/**
 * The markup an HTML-template chat message renders in the sandboxed email preview.
 *
 * Only `jsonData.source.editorType === "html"` messages are decoded: edular-core set that field only on
 * workflow/contact-strategy messages sent between 2024-06-05 (4f93d056a) and 2024-06-27 (7802f55f6),
 * when it still escaped the HTML template text (`<p>&lt;div&gt;…</p>`). Everything else is real HTML
 * and is passed through untouched, so escaped text stays text.
 */
export const getHtmlEmailMarkup = (message: {content?: string; jsonData?: any}): string => {
    const html: string = message.jsonData?.email?.html ?? message.content ?? ""
    if (message.jsonData?.source?.editorType !== Communication.EditorType.Html) {
        return html
    }
    return decodeEntities(html.replace(/\\n/g, "\n"))
}
